import { message, Modal } from 'antd'
import { useTranslation } from 'react-i18next'
import { EntVetProduct } from '../../../../../models/handBooks/vetProduct'
import { getCookie } from 'typescript-cookie'
import {
	useAddVeterinaryProductTypeMutation,
	useDeleteVeterinaryProductTypeMutation,
	useEditVeterinaryProductTypeMutation,
} from '../../../../../redux/api/handBooksApi/veterinary/veterinaryProductionApi'

const useTypeVeterinaryProduct = (modal: any, refresh?: () => void) => {
	const { t } = useTranslation()
	const { confirm } = modal
	const [addTypeVeterinaryProduct] = useAddVeterinaryProductTypeMutation()
	const [deleteTypeVeterinaryProduct] = useDeleteVeterinaryProductTypeMutation()
	const [editTypeVeterinaryProduct] = useEditVeterinaryProductTypeMutation()
	async function onAddTypeVeterinaryProduct(
		newTypeVeterinaryProduct: EntVetProduct
	): Promise<boolean> {
		try {
			let status: boolean = false
			await addTypeVeterinaryProduct(newTypeVeterinaryProduct)
				.then((response: any) => {
					if (response.error) {
						const isKyrgyz = getCookie('i18next') === 'ky'
						const lang = isKyrgyz ? 'kg' : 'ru'
						const res = response.error.data?.res
						const errorMessages = Array.isArray(res)
							? res.map((error: any) => error[lang] || error.ru).join('\n')
							: response.error.data?.msg || t('unknownError')
						throw new Error(errorMessages)
					}
					if (response.data.success) {
						status = true
						message.success(t('msg.successAdd'))
						if (refresh) refresh()
					}
				})
				.catch((error: any) => {
					modal.error({ title: t('msg.error'), content: String(error.message) })
				})
			return status
		} catch (error: any) {
			modal.error({ title: t('msg.error'), content: String(error.message) })
			return false
		}
	}
	async function onDeleteTypeVeterinaryProduct(typeVeterinaryProduct: EntVetProduct) {
		try {
			let status: boolean = false
			confirm({
				centered: true,
				title: t('msg.confirmDeleteText'),
				okText: t('general.yes'),
				cancelText: t('general.no'),
				onOk() {
					deleteTypeVeterinaryProduct(typeVeterinaryProduct.id as number)
						.then((response: any) => {
							if (response.error) {
								const isKyrgyz = getCookie('i18next') === 'ky'
								const lang = isKyrgyz ? 'kg' : 'ru'
								const res = response.error.data?.res
								const errorMessages = Array.isArray(res)
									? res.map((error: any) => error[lang] || error.ru).join('\n')
									: response.error.data?.msg || t('unknownError')
								throw new Error(errorMessages)
							}
							if (response.data.success) {
								status = true
								Modal.success({ title: t('msg.successDelete') })
								if (refresh) refresh()
							}
						})
						.catch((error: any) => {
							Modal.error({ title: t('msg.error'), content: String(error.message) })
						})
				},
			})
			return status
		} catch (error: any) {
			Modal.error({ title: t('msg.error'), content: String(error.message) })
			return false
		}
	}
	async function onEditTypeVeterinaryProduct(
		editedTypeVeterinaryProduct: EntVetProduct
	): Promise<boolean> {
		try {
			let status: boolean = false
			await editTypeVeterinaryProduct(editedTypeVeterinaryProduct)
				.then((response: any) => {
					if (response.error) {
						const isKyrgyz = getCookie('i18next') === 'ky'
						const lang = isKyrgyz ? 'kg' : 'ru'
						const res = response.error.data?.res
						const errorMessages = Array.isArray(res)
							? res.map((error: any) => error[lang] || error.ru).join('\n')
							: response.error.data?.msg || t('unknownError')
						throw new Error(errorMessages)
					}
					if (response.data.success) {
						status = true
						Modal.success({ title: t('msg.successEdited') })
						if (refresh) refresh()
					}
				})
				.catch((error: any) => {
					Modal.error({ title: t('msg.error'), content: String(error.message) })
				})
			return status
		} catch (error: any) {
			Modal.error({ title: t('msg.error'), content: String(error.message) })
			return false
		}
	}
	return { onAddTypeVeterinaryProduct, onDeleteTypeVeterinaryProduct, onEditTypeVeterinaryProduct }
}
export { useTypeVeterinaryProduct }
